import type { Breadcrumb } from '#lib/components/page/Breadcrumbs.svelte';
import type { TimeRangeSettings } from '#lib/components/page/TimeRangeEnum.svelte';

export function withBreadcrumb<T, P extends { breadcrumbs: Breadcrumb[] }>(crumb: Breadcrumb) {
  return async (init: { data: T; parent: () => Promise<P> }) => {
    const parent = await init.parent();

    return <const>{
      ...parent,
      breadcrumbs: [...parent.breadcrumbs, crumb] as Breadcrumb[],
      ...init.data,
    };
  };
}

export function withBreadcrumbAndTime<T, P extends { breadcrumbs: Breadcrumb[] }>(
  crumb: Breadcrumb,
  timeRangeSettings: TimeRangeSettings = {},
) {
  const fn = withBreadcrumb<T, P>(crumb);

  return async (init: { data: T; parent: () => Promise<P> }) => {
    return <const>{
      ...(await fn(init)),
      timeRangeSettings,
    };
  };
}
